<script>
    import {flagTypes} from '../../../constants.js';
    import {sgettext} from '../../../i18n.js';
    let row_value;
    export let row;
    if(row) {
        row_value = row.type.toLocaleLowerCase().replace(/^\w/, c => c.toLocaleUpperCase())
    }

</script>

<div>{sgettext(row_value)}</div>
<div class="text-gray-600">
    {#if row.linked_issues.length && row.linked_issues[0].type === flagTypes.additionalWorkRequired}
        ({sgettext('$$VIA_SAP_NOTIFICATION_1$$')})
    {/if}
</div>